import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { homestayInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1F4D3A] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">W</span>
              </div>
              <div>
                <h3 className="font-bold text-lg">White Orchid</h3>
                <p className="text-sm text-white/70">Homestay Kurseong</p>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              Experience peaceful hospitality in the heart of Kurseong's pine forests with spectacular Mt. Kanchenjunga views.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-white/80 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rooms" className="text-sm text-white/80 hover:text-white transition-colors">
                  Rooms & Tariff
                </Link>
              </li>
              <li>
                <Link to="/experiences" className="text-sm text-white/80 hover:text-white transition-colors">
                  Experiences
                </Link>
              </li>
              <li>
                <Link to="/availability" className="text-sm text-white/80 hover:text-white transition-colors">
                  Check Availability
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm text-white/80 hover:text-white transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/80 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/80 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href={`tel:${homestayInfo.phone}`} className="text-sm text-white/80 hover:text-white transition-colors">
                  {homestayInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${homestayInfo.email}`} className="text-sm text-white/80 hover:text-white transition-colors break-all">
                  {homestayInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-white/80">
                  Near Dowhill School, Kurseong, Darjeeling, West Bengal 734220
                </span>
              </li>
            </ul>
          </div>

          {/* Social & Rating */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Connect With Us</h4>
            <div className="flex gap-3 mb-6">
              <a
                href={`https://www.instagram.com/${homestayInfo.social.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={`https://www.facebook.com/${homestayInfo.social.facebook}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <div className="bg-white/10 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-2xl font-bold">{homestayInfo.rating}</span>
                <span className="text-yellow-400">★★★★★</span>
              </div>
              <p className="text-sm text-white/70">{homestayInfo.reviewCount}+ Google Reviews</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-6 text-center">
          <p className="text-sm text-white/60">
            © {currentYear} White Orchid Homestay. All rights reserved. | Running since {homestayInfo.established}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
